import { render, staticRenderFns } from "./AnteprimaStatoFasi.vue?vue&type=template&id=0e97157c&scoped=true"
import script from "./AnteprimaStatoFasi.vue?vue&type=script&lang=js"
export * from "./AnteprimaStatoFasi.vue?vue&type=script&lang=js"
import style0 from "./AnteprimaStatoFasi.vue?vue&type=style&index=0&id=0e97157c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97157c",
  null
  
)

export default component.exports